import { render, staticRenderFns } from "./HireRequest.vue?vue&type=template&id=2523a1f6&"
import script from "./HireRequest.vue?vue&type=script&lang=js&"
export * from "./HireRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports